



















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator'
import { elTableHeaderCellStyle } from '@/utils/table'
@Component
export default class TableFormComponent extends Vue {
    @Prop() private tableData!: any
    @Prop({ default: 0 }) private total!: number
    @Prop({ default: true }) private pagination!: boolean
    @Prop() private currentPage!: number
    @Watch('tableData')
    getNewData(v: any[]) {
        // console.log(JSON.stringify(v, null, 2))
        this.$nextTick(() => {
            this.newTableData = v
        })
    }

    newTableData: any[] = []
    current = 1
    size = 10
    pageSizes = [5, 10, 20, 50]
    headerCellStyle = elTableHeaderCellStyle

    handleSizeChange(val) {
        this.size = val
        this.fetchData()
    }

    handleCurrentChange(val) {
        this.current = val
        this.fetchData()
    }

    @Emit()
    fetchData() {
        const { current, size } = this
        return { current, size }
    }

    @Watch('currentPage')
    onCurrentPageChange(currentPage: number): void {
        this.current = currentPage
    }
}
